<template>
    <div class="apprentice-simple-card">
        <div class="header">
            <b-badge
                class="main-badge"
                variant="warning">
                {{ $t('group_pair.in_progress') }}
            </b-badge>

            <div
                class="teacher-coordinator-status"
                v-if="checktBoth">
                <div class="teacher">
                    <span class="label">
                        {{ $t('group_pair.assessment_teacher') }}
                    </span>

                    <b-badge :variant="getStatusColor(teacherStatus)">
                        {{ teacherStatus }}
                    </b-badge>
                </div>

                <div class="coordinator">
                    <span class="label">
                        {{ $t('group_pair.assessment_administrator') }}
                    </span>

                    <b-badge :variant="getStatusColor(coordinatorStatus)">
                        {{ coordinatorStatus }}
                    </b-badge>
                </div>
            </div>
        </div>

        <design-2021-group-pair-log-component :activities-in="groupPairGroup.activities">
        </design-2021-group-pair-log-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-pair-status-component',
    props: {
        groupIn: Object,
    },
    data() {
        return {
            groupPairGroup: this.groupIn.group_pair_groups[0],
        };
    },
    computed: {
        checktBoth() {
            return this.groupIn.group_pair_options.check_option === 2;
        },
        teacherStatus() {
            return this.groupPairGroup.check_teacher === 2
                ? this.$t('group_pair.approved')
                : this.$t('group_pair.awaiting');
        },
        coordinatorStatus() {
            return this.groupPairGroup.check_coordinator === 2
                ? this.$t('group_pair.approved')
                : this.$t('group_pair.awaiting');
        },
    },

    methods: {
        getStatusColor(status) {
            switch (status) {
                case this.$t('group_pair.approved'):
                    return 'success';
                    break;

                case this.$t('group_pair.awaiting'):
                    return 'warning';
                    break;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;

    margin-bottom: map-get($grid-gutter-spacing, 'sixty');
}

.main-badge {
    font-size: $base-font-size;
    padding: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen');
}

.teacher-coordinator-status {
    flex: 1 0 100%;
    margin-top: map-get($grid-gutter-spacing, 'fifteen');

    .teacher,
    .coordinator {
        .label {
            display: inline-block;
            width: 180px;
        }

        .badge {
            margin-left: map-get($grid-gutter-spacing, 'fifteen');
            font-size: $default-font-size;
            padding: map-get($grid-gutter-spacing, 'four') map-get($grid-gutter-spacing, 'eight');

            &.badge-success {
                color: $white;
            }
        }
    }

    .teacher {
        .label {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .header {
        column-gap: $grid-gutter-width;
    }

    .teacher-coordinator-status {
        flex: 0 1 calc(100% - 194px);
        margin-top: 0;
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .header {
        column-gap: map-get($grid-gutter-spacing, 'sixty');
    }

    .teacher-coordinator-status {
        flex: 0 1 calc(100% - 205px);
    }
}
</style>
